module.exports = __webpack_public_path__ + "static/management-of-the-absurd-06af55165ed693d275c80d026b3a65e1.jpg";